import {
    ActionTypes
} from './model';

const initState = {};

export default function handler(state = initState, actions) {
    if (actions.type == ActionTypes.CHANGE_MAP_VIEW) {
        state.content[state.tabIndex] = {
            ...state.content[state.tabIndex],
            ...actions.payload
        };
        return {
            ...state
        };
    }
    if (actions.type == ActionTypes.CHANGE_TAB) {
        return {
            ...state
        };
    }
    return state;
}